import { useState, useEffect } from 'react';
import { useForm } from '../../hooks';

import { Typography } from '@mui/material';

import { Button, TextField, Form } from '../common';
import { auth, emailValidator } from '../../utils';
import FormSubmitted from './FormSubmitted';
import colors from '../../assets/colors';
import texts from '../../assets/texts';

export default function ForgotPasswordForm(props) {
  const { handleChange, values } = useForm({ email: '' });
  const [infoText, setInfoText] = useState('');
  const [error, setError] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isFormDataComplete, setIsFormDataComplete] = useState(false);

  useEffect(() => {
    if (values.email.length > 0 && emailValidator(values.email)) {
      setIsFormDataComplete(true);
    } else {
      setIsFormDataComplete(false);
    }
  }, [values.email, values.email.length]);

  const handleSubmit = (e) => {
    e.preventDefault();
    auth
      .resetPassword(values.email)
      .then(function () {
        setError(false);
        setSubmitted(true);
      })
      .catch((err) => {
        setError(true);
        if (err.response.data === 'User not found!') {
          setInfoText('Użytkownik o danym email-u nie istnieje.');
        } else {
          setInfoText(err.response.data);
        }
      });
  };

  return (
    <>
      {!submitted ? (
        <>
          <Typography variant="h4" sx={{ mt: 10, fontWeight: 600 }}>
            Zresetuj hasło
          </Typography>
          <Typography variant="h6" sx={{ mt: 8, fontWeight: 500 }}>
            Zapomniałeś swoje hasło? Nic straconego!
          </Typography>
          <Typography
            variant="h6"
            sx={{ m: 0, fontWeight: 500, textAlign: 'center' }}
          >
            Wystarczy, że podasz adres email, którego użyłeś podczas rejestracji
            a my prześlemy link pozwalający na odnowienie hasła
          </Typography>

          {infoText !== '' && !error && (
            <Typography
              sx={{ color: colors.agroweGreen, mt: 2, fontWeight: 500 }}
            >
              {infoText}
            </Typography>
          )}
          {error && (
            <Typography
              sx={{
                color: colors.redError,
                mt: 2,
                fontWeight: 500,
              }}
            >
              {infoText}
            </Typography>
          )}

          <Form noValidate>
            <TextField
              login
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="ADRES E-MAIL"
              name="email"
              autoComplete="email"
              onChange={handleChange('email')}
              autoFocus
              error={values.email.length > 0 && !emailValidator(values.email)}
              helperText={
                values.email.length > 0 && !emailValidator(values.email)
                  ? 'Nieprawidłowy adres email!'
                  : 'Pola oznaczone * są wymagane'
              }
              sx={{ mt: 5 }}
              InputLabelProps={{ shrink: true }}
              inputProps={{ 'data-testid': 'email' }}
            />
            <Button
              login
              type="submit"
              fullWidth
              variant="outlined"
              size="large"
              disabled={!isFormDataComplete}
              onClick={handleSubmit}
              sx={{ mt: 5 }}
              aria-label="reset"
            >
              Zresetuj hasło
            </Button>
          </Form>
        </>
      ) : (
        <FormSubmitted
          documentTitle={props.documentTitle}
          title="Link został wysłany"
          description={texts.passwordResetLinkSent}
          buttonText="Wróć do strony głównej"
        />
      )}
    </>
  );
}
